import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { APIService } from '../../../../core/providers/apiservices';

@Injectable()
export class UploadProvider {

  maxRetries = 20;
  blockLength = 1000 * 1024;
  numberOfBlocks = 1;
  currentChunk = 1;
  retryAfterSeconds = 3;

  private header:any=APIService.getHeader();
  items:any=[];
  item:any;
  files:any=[];

  estudioret:any;
  mfileName:any;
  mfileExtension:any;
  mfileBase64:any;
  mUrl:any;
  midRoteiro:any;
  percentualEnvio=0;
  taskUploadRunning:any;
  constructor(private http: HttpClient) {
    
  }

  getListaUploads(){
    //this.blockLength=size;
    var me=this;
    
    return new Promise((resolve, reject) => {

    me.header=APIService.getHeader();
    let url = APIService.API_URL + "uploadfile";
    this.http.get(url,{headers:me.header})
      .subscribe((result: any) => {
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data ={
              'item': jsonData,
              'status_ret':'',
              'erro':''
            }
            me.item=data;
        
        }
        else{
          var data1 ={
            'item': null,
            'status_ret':'NOK',
            'erro':'sem arquivos'
          }
          
          me.item=data1;
        }
        resolve(me.item);
      },
      (error) => {
        var data2 ={
          'item': null,
          'status_ret':'NOK',
          'erro':'erro na chamada'
        }
        me.item=data2;
        reject(me.item);
        //resolve(me.login);
      });
    });

  }

  uploadMetaData(idSession:any, fileName:any, fileExtension:any, size:any, fileBase64:any){
    var me=this;
    this.mfileName=fileName;
    this.mfileExtension=fileExtension;
    //this.midRoteiro=idRoteiro;
    this.mfileBase64=fileBase64;

    this.numberOfBlocks = Math.ceil(size / this.blockLength);
    var name = this.mfileName;
    this.currentChunk = 1;
    me.header=APIService.getHeader();
  
    return new Promise((resolve, reject) => {
    let url = APIService.API_URL + "uploadfile?idSession=" + idSession + "&blocksCount=" + me.numberOfBlocks + "&fileName=" + name + "&fileSize=" + size ;
    var data={"idSession":idSession};
    var requestData=JSON.stringify(data);
    this.http.post(url,requestData,{headers:me.header})
      .subscribe({
        next: (result: any) => {
          var jsonData=result;
          if (jsonData.length!=0)
          {
            if (jsonData.status == true)
            {
              var success=[{
                'filename':jsonData.fileName,
                'status_ret':'',
                'erro':''
              }]
              me.items=success;
            }
          }
          else{
            var errodatavazio=[{
              'status_ret':'NOK',
              'erro':'Sem estúdios.'
            }]
            me.items=errodatavazio;
          }
          resolve(me.items);
        },
        error: (error) => {
          var errochamada=[{
            'item':null,
            'status_ret':'NOK',
            'erro':error._body
          }]
          me.items=errochamada;
          reject(me.items);
        }
      });

    });

  }

  arrayBufferToBase64(buffer:any) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }


  sendFileNEW  (currentChunk:any,lchunck:any, idSession:any)
  {
      var me=this;
      me.header=APIService.getHeader();

      var nameFile=idSession;
      var base64chunck=me.arrayBufferToBase64(lchunck);
      
      var fileChunk={
        Slice:base64chunck
      }

      return new Promise((resolve, reject) => {
        let url = APIService.API_URL + "uploadfilecontent?blockAtu=" + currentChunk + "&idSession=" + nameFile;
        var requestData=JSON.stringify(fileChunk);
        me.http.post(url,requestData,{headers:me.header})
          .subscribe({
            next: (result: any) => {
              var jsonData=result;
              if (jsonData.length!=0)
              {
                var errochamada=[{
                  'item':jsonData,
                  'status_ret':'',
                  'erro':''
                }]
                me.items=errochamada;
                if (jsonData.isLastBlock)
                {
                   // ...existing code...
                }
              }
              resolve(me.items);
            },
            error: (error) => {
              var errochamada=[{
                'item':null,
                'status_ret':'NOK',
                'erro':error._body
              }]
              me.items=errochamada;
              reject(me.items);
            }
          });
      });
    
  }


}
